module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Content_VrSceneViewer', {
		configure: function(options) {
			this.TYPE_VR_VIDEO = 4;
			this.registerOptions('', {
				widgets: {
					sceneDl: {
						fields: ['type'],
						'transitParameters.v1': 'ykYa8ALmUD'
					},
					downloadButton: {
						widget: 'Widget',
						'embed.container': '.download-block',
						'embed.widget': '@parent #currentScene #list',
						autoRender: false,
						templateOptions: {
							iconDownload: 'icon-download'
						},
						'hooks.onStartRendering': function () {
							var dl = this.getParent().wom1('#sceneDl');
							var downloadAccess = window.Number(dl.getObjectValue('accessibility.downloadable'));
							var permitionsGuest = !this.wom1('@root .PermissionManager').hasAccess('member') || !fox.site.member;

							if (!dl.isLoaded()) {
								this.wait(dl, 'loaded').then(this.render.bind(this));
								return;
							}
							if (permitionsGuest ){
								this.setTemplateOptions({url: fox.getEnv('siteProps.ubs.joinUrl') || '/join',});
							}
							if (!downloadAccess) {
								this.fragment = document.createDocumentFragment();
								return false;
							} else {
								this.setOption('template', 'video_download');
							}
						},
						'handleDom.downloadLinks': {
							target: '.download',
							event: 'click',
							callback: function (elem) {
								var dLinks = this.rwom1('@parent #downloadLinks');
								var container = dLinks.getOption('container');
								var activeClass = dLinks.getOption('activeClass');
								var activeItems = dLinks.getOption('activeItems');

								if (!$(elem).hasClass(activeClass)) {
									var w = ($(container).outerWidth() / 2) - ($(elem).outerWidth() / 2);

									$(container).css({ 'margin-left': '-' + w + 'px' });
								}

								$(elem).toggleClass(activeClass);
								$(container).toggleClass('active');

								if (activeItems) {
									$(container).find('li').toggleClass(activeClass);
								}
							}
						}
					},
					downloadLinks: {
						widget: 'Widget',
						'container': '.download-links',
						template: 'sitepage_scene_links',
						autoRender: false,
						handleWom: {
							getFormat: {
								widget: '@parent #flashPlayer',
								event: '_changeFormat',
								callback: '@parent: setDownloadLinks'
							},
							getVrFormat: {
								widget: '@parent #vrPlayer',
								event: '_changeFormat',
								callback: '@parent:setDownloadLinks'
							}
						}
					},
					flashPlayer: {
						widget: 'Content_Html5Player',
						container: '.player-block-wrapper',
						template: 'sitepage_scene_video',
						renderPlayer: true,
						renderTo: '.player',
						autoRender: true,
						active: false,
						group: 'player',
						'embed.widget': '@parent #currentScene #list',
						'html5PlayerConfig.movie.autoplay': true
					},
					vrPlayer: {
						widget: 'VrPlayer',
						container: '.player-block-wrapper',
						template: 'vrVideo',
						autoRender: true,
						active: false,
						group: 'player',
						'embed.widget': '@parent #currentScene #list'
					},
					guestDisablePreview: {
						widget: 'guestDisablePreview',
						autoRender: true,
						dl: '@parent #sceneDl',
						container: '.player-block-wrapper',
						active: false,
						group: 'player',
						'embed.widget': '@parent #currentScene #list',
						
					}
				}
			});
			this.callParent('configure', arguments);
		},

		runScene: function () {
			this.sceneDl = this.requireEmbeddedWidget('sceneDl');

			this.sceneDl.addFilter('id', ['id'], [this.contentId]).load();

			if (!this.sceneDl.isLoaded()) {
				this.handleEvent(this.sceneDl, 'loaded', fox.bind(function () {
					this.setTitle();
					this.switchPlayer();
				}, this));
			} else {
				this.switchPlayer();
			}
		},

		switchPlayer: function() {
			var scene = this.sceneDl.getCollection();
			var showPreview = this.sceneDl.getObjectValue('accessibility.previewsForGuests');
			var permitionsGuest = !this.wom1('@root .PermissionManager').hasAccess('member') || !fox.site.member;

			if (!showPreview && permitionsGuest) {
		
				this.switchEmbeddedWidget('guestDisablePreview');
			} else {
				if (scene.length === 1) {
					if (scene[0].type === this.TYPE_VR_VIDEO) {
						this.switchEmbeddedWidget('vrPlayer');
					} else {
						this.switchEmbeddedWidget('flashPlayer');
					}
				}
			}
			

			this.dispatchEvent('setContentId', this.contentId);
		},

		rebuildFormatMap:function(map) {
			map.total = 0;
			for(var key in map.download) {
				++ map.total;
				if (key.indexOf('_vr_') !== -1) {
					map.download[key].vr = 1;
				}
			}
			return map;
		},

		setDownloadLinks: function(obj, player) {
			var formatMap = player.getFormatMap();
		
			if (!$.isEmptyObject(formatMap.download)) {
				$('.toggleDownloads').removeClass('hidden');

				var map = this.rebuildFormatMap(formatMap);
				this.rwom1('#downloadLinks').setTemplateOptions({
					download: map.download,
					total: map.total
				}).render();
			}
		},

		openDownloadBlock: function () {
			var $container = $(this.rwom1('#downloadLinks').getOption('container'));
			var $elt = $('.toggleDownloads');
			var $list = $container.find('.download-links');

			$elt.addClass('active');
			$list.addClass('active');
		},

		closeDownloadBlock: function () {
			var $container = $(this.rwom1('#downloadLinks').getOption('container'));
			var $elt = $('.toggleDownloads');
			var $list = $container.find('.download-links');

			$elt.removeClass('active');
			$list.removeClass('active');
		},

		_setDownloadBlockWidth: function (elt, w) {
			var $container = $(w.getOption('container')),
				togglerW = $(elt).innerWidth(),
				$links = $container.find('.download-links'),
				width = 0;

			$links.find('li').each(function(i, el){
				width += $(el).outerWidth(true);
			});

			if (togglerW > width) {
				width = togglerW;
			}

			$links.width(width);
		},
		setTitle: function () {
			var data = this.sceneDl.getCollection()[0];
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			var parseTitle = fox.Navigator.get(2) ? decodeURIComponent(fox.Navigator.get(2).replace(/-/g, ' ')) : '';

			document.title = parseTitle + ' - Sex Movies Featuring ' + fox.getEnv('screenName');
			data.description != '' ? metaDescription.setAttribute('content', data.description) : metaDescription.setAttribute('content', 'Watch ' + fox.getEnv('screenName') + ' Best Porn Videos in HD. Free movies ' + parseTitle + '.');
		}


	}, 'Content_SceneViewer');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sceneViewer.js
// module id = 871
// module chunks = 4